import {getProducts, getProductsCategories, getProductsSubCategories} from './thunk';

export const builderGetProductsCategories = (builder: any) => {
  builder.addCase(getProductsCategories.pending, (state: any) => {
    state.categoriesLoading = true;
    state.categoriesError = '';
  });
  builder.addCase(getProductsCategories.fulfilled, (state: any, action: any) => {
    state.categoriesLoading = false;
    state.categoriesError = '';
    state.categories = action.payload?.data || [];
  });
  builder.addCase(getProductsCategories.rejected, (state: any, action: any) => {
    state.categoriesLoading = false;
    state.categoriesError = action.error?.message || 'خطایی در دریافت دسته‌بندی‌ها رخ داده است';
  });
};

export const builderGetProductsSubCategories = (builder: any) => {
  builder.addCase(getProductsSubCategories.pending, (state: any) => {
    state.subCategoriesLoading = true;
    state.subCategoriesError = '';
  });
  builder.addCase(getProductsSubCategories.fulfilled, (state: any, action: any) => {
    state.subCategoriesLoading = false;
    state.subCategoriesError = '';
    state.subCategories = action.payload?.data || [];
  });
  builder.addCase(getProductsSubCategories.rejected, (state: any, action: any) => {
    state.subCategoriesLoading = false;
    state.subCategoriesError =
      action.error?.message || 'خطایی در دریافت زیردسته‌بندی‌ها رخ داده است';
  });
};

export const builderGetProducts = (builder: any) => {
  builder.addCase(getProducts.pending, (state: any) => {
    state.productsLoading = true;
  });
  builder.addCase(getProducts.fulfilled, (state: any, action: any) => {
    const data = action.payload?.data || {};

    // remove items with duplicate id
    const uniqueProducts = data?.items?.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    );
    data.items = uniqueProducts || [];

    if (data?.page > 1) {
      const prevProducts = state.products?.items || [];
      state.products = {
        ...data,
        items: [...prevProducts, ...uniqueProducts].filter(
          (item, index, self) => index === self.findIndex((t) => t.id === item.id)
        )
      };
    } else {
      state.products = data;
    }

    state.productsLoading = false;
  });
  builder.addCase(getProducts.rejected, (state: any, action: any) => {
    state.productsError = action.error?.message || 'خطایی در دریافت محصولات رخ داده است';
    state.productsLoading = false;
  });
};
